import { Button } from '@curology/ui-components-web/react/Button';
import { ProductCard } from '@curology/ui-components-web/react/Card/ProductCard';
import { ProductCardContent } from '@curology/ui-components-web/react/Card/ProductCard/ProductCardContent';
import { ProductCardImage } from '@curology/ui-components-web/react/Card/ProductCard/ProductCardImage';
import { AgencyMinusIcon } from '@curology/ui-components-web/react/Icon/icons/AgencyMinusIcon';
import { AgencyPlusIcon } from '@curology/ui-components-web/react/Icon/icons/AgencyPlusIcon';
import { MinusIcon } from '@curology/ui-components-web/react/Icon/icons/MinusIcon';
import { PlusIcon } from '@curology/ui-components-web/react/Icon/icons/PlusIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { RxCardPricing } from '@/components/product-selection/components/RxCardPricing/RxCardPricing';
import { useSelectedItemIds } from '@/components/product-selection/hooks/useSelectedItemIds';
import { DATA_KEYS } from '@/consts/dataKeys';
import { type Card } from '@/types/productSelectionAndCheckout/types';

const brandMinusIcons = {
  curology: MinusIcon,
  agency: AgencyMinusIcon,
} as const;

const brandPlusIcons = {
  curology: PlusIcon,
  agency: AgencyPlusIcon,
} as const;
export const AddRxCard = ({
  alternateRxCard,
  isSelected,
}: {
  alternateRxCard: Card;
  isSelected: boolean;
}) => {
  const { patient, brand } = useDataProvider(DATA_KEYS.productSelection);
  const { toggleCard } = useSelectedItemIds();

  const BrandMinusIcon = brandMinusIcons[brand];
  const BrandPlusIcon = brandPlusIcons[brand];

  return (
    <ProductCard>
      <ProductCardContent
        horizontal
        className="-cur-mb-3"
        image={
          <div className="cur-flex cur-flex-col cur-h-full cur-w-full cur-aspect-[3/4]">
            <ProductCardImage
              alt={alternateRxCard.modal.image.alt}
              aspectRatio="auto"
              className="cur-h-full"
              src={alternateRxCard.modal.image.url}
            />
          </div>
        }
        meta={
          <>
            <Typography size="body">
              {alternateRxCard.bodyDescription}
            </Typography>
            <RxCardPricing rxCard={alternateRxCard} />
            <Button
              buttonType={isSelected ? 'secondary' : 'primary'}
              onClick={() => {
                toggleCard({ card: alternateRxCard, patient });
              }}
              iconStart={isSelected ? BrandMinusIcon : BrandPlusIcon}
            >
              {isSelected ? 'Remove' : 'Add'}
            </Button>
          </>
        }
        title={
          <Typography as="p" size="h3" weight="bold">
            {alternateRxCard.name}
            <sup>Rx</sup>
          </Typography>
        }
      ></ProductCardContent>
    </ProductCard>
  );
};
